<div *ngIf="chgPwd" class="card border-0 shadow">
  <div class="card-body">
    <div class="d-flex flex-column">
      <div class="row">
        <div class="d-flex justify-content-center col-md-4">
          <img class="bidit-logo" alt="BiditWeb" src="assets/img/Bidit_Logo.png" />
        </div>

        <div class="col-md-8">
          <p class="text-bidit-primary-header">Change Your Password</p>
          <p class="row warning font-weight-bold col-md-11">Enter your new password below and click submit.</p>
          <div>
            Requirements:
            <ul>
              <li class="bidit-alert">
                Password must be at least 8 characters long
              </li>
              <li class="bidit-alert">
                Password must have at least 1 upper case and 1 lower case letter
              </li>
              <li class="bidit-alert">
                Password must have at least 1 number or special character
              </li>
            </ul>

          </div>
          <form #form="ngForm" (ngSubmit)="changePassword(form)" appValidatePasswords>
            <div class="form-group">
              <input id="email" type="text" required name="email" tmFocus validateEmail class="form-control" [(ngModel)]="chgPwd.email"
                     #email="ngModel"
                     placeholder="email">
              <small [hidden]="!form.submitted || email.valid" class="text-danger">
                Please enter a valid email
              </small>
            </div>
            <div class="form-group">
              <input id="password" type="password" required name="password" class="form-control" [(ngModel)]="chgPwd.newPassword"
                     #password="ngModel"
                     [ngModelOptions]="{updateOn: 'blur'}"
                     placeholder="new password">
              <small [hidden]="!form.submitted || password.valid" class="text-danger">
                Please enter a password
              </small>
            </div>
            <div class="form-group">
              <input id="confirmPassword" type="password" required name="confirmPassword" class="form-control" [(ngModel)]="chgPwd.confirmPassword"
                     #confirmPassword="ngModel"
                     [ngModelOptions]="{updateOn: 'submit'}"
                     placeholder="confirm new password">
              <small [hidden]="!form.submitted || confirmPassword.valid" class="text-danger">
                Please enter a password
              </small>
              <div class="row">
                <small *ngIf="form.submitted && form.errors?.passwordsMismatch" class="col text-danger">
                  New Password and Confirm Password do not match
                </small>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-bidit-action" [disabled]="isRequesting">Submit</button>
              <app-spinner [isRunning]="isRequesting"></app-spinner>
            </div>
            <div *ngIf="errors" class="row alert alert-danger" role="alert">
              <strong>{{errors}}</strong>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
